import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { IOfferService } from '../../../service/ioffer.service';


@Injectable()
export class IVerificationGuard implements CanActivate {

    constructor(private iOfferService: IOfferService, private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.iOfferService.checkToken(next.params.token)
            .pipe(
                switchMap(() => of(true)),
                catchError(() => of(this.router.parseUrl('/ioffer/no-state')))
            );
    }
}
